import { createAsyncThunk } from "@reduxjs/toolkit";
import type { AttributeLabels } from "@interfaces/attributeLabels";
import userService from "@/endpoints/userService";
import ShowToaster from "@/toaster";

export const fetchAttributeLabels = createAsyncThunk<
  AttributeLabels | null,
  { marketIds: number[] },
  { rejectValue: string }
>(
  "attributeLabels/fetchAttributeLabels",
  async ({ marketIds = [] }, thunkAPI) => {
    try {
      const response: AttributeLabels =
        (await userService.attributeLabels.fetch(marketIds)) as any;
      if (response) {
        return response;
      }
      return null;
    } catch (err: any) {
      ShowToaster.error("Failed to fetch attribute labels.");
      return thunkAPI.rejectWithValue(
        "Failed to fetch attribute labels." + err.message
      );
    }
  }
);
